(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-video-analyses.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-video-analyses.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  useCallback,
  useEffect
} = React;
const {
  actions: {
    fetchVideoAnalyses,
    clearVideoAnalyses,
    clearError
  },
  selectors: {
    selectVideoAnalyses,
    selectVideoAnalysesLoading,
    selectVideoAnalysesError,
    selectVideoAnalysesDrawNumber,
    selectVideoAnalysesLastFetched,
    selectDrawVideo,
    selectAllMatchVideos,
    selectHasDrawVideo,
    selectHasMatchVideos,
    selectHasAnyVideos
  }
} = svs.components.tipsen.store.reducers.videoAnalysesSlice;

const useVideoAnalyses = _ref => {
  let {
    drawNumber,
    categories,
    autoFetch = true
  } = _ref;
  const dispatch = useDispatch();
  const videos = useSelector(selectVideoAnalyses);
  const loading = useSelector(selectVideoAnalysesLoading);
  const error = useSelector(selectVideoAnalysesError);
  const currentDrawNumber = useSelector(selectVideoAnalysesDrawNumber);
  const lastFetched = useSelector(selectVideoAnalysesLastFetched);

  const drawVideo = useSelector(selectDrawVideo);
  const matchVideos = useSelector(selectAllMatchVideos);
  const hasDrawVideo = useSelector(selectHasDrawVideo);
  const hasMatchVideos = useSelector(selectHasMatchVideos);
  const hasAnyVideos = useSelector(selectHasAnyVideos);
  const fetchVideos = useCallback(function () {
    let overrideOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const fetchOptions = _objectSpread({
      drawNumber,
      categories
    }, overrideOptions);
    if (!fetchOptions.drawNumber) {
      return Promise.reject(new Error('drawNumber is required'));
    }
    return dispatch(fetchVideoAnalyses(fetchOptions));
  }, [dispatch, drawNumber, categories]);
  const clearVideos = useCallback(() => {
    dispatch(clearVideoAnalyses());
  }, [dispatch]);
  const clearVideoError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  useEffect(() => {
    if (!autoFetch || !drawNumber) {
      return;
    }
    const shouldFetch = currentDrawNumber !== drawNumber || !loading && !lastFetched && !error;
    if (shouldFetch) {
      fetchVideos();
    }
  }, [autoFetch, drawNumber, currentDrawNumber, loading, lastFetched, error, fetchVideos]);

  const isDataCurrent = currentDrawNumber === drawNumber && Boolean(lastFetched);
  return {
    videos: isDataCurrent ? videos : {},
    drawVideo: isDataCurrent ? drawVideo : null,
    matchVideos: isDataCurrent ? matchVideos : {},
    loading,
    error,
    lastFetched: isDataCurrent ? lastFetched : null,
    hasVideos: isDataCurrent && hasAnyVideos,
    hasDrawVideo: isDataCurrent && hasDrawVideo,
    hasMatchVideos: isDataCurrent && hasMatchVideos,
    isEmpty: isDataCurrent && !loading && !hasAnyVideos && Boolean(lastFetched),
    isDataCurrent,
    fetchVideos,
    clearVideos,
    clearError: clearVideoError,
    refetch: () => fetchVideos()
  };
};
setGlobal('svs.components.tipsen.hooks.useVideoAnalyses', useVideoAnalyses);

 })(window);